import config from '../config'
import http from '../http'

export default{
    getTransfer:async function(payload) {
        const res = await http({
                url: config.TIKTOK_CATEGORY_TRANSFER,
                method: 'post',
                data:payload
            })
        return res.data
    },
    getTikTokWareHouse:async function(payload) {
        const res = await http({
                url: config.GET_TIKTOK_WAREHOUSE,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },
    getTikTokBrand:async function(payload) {
        const res = await http({
                url: config.GET_TIKTOK_BRAND,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },
    getTikTokAttribute:async function(payload) {
        const res = await http({
                url: config.GET_TIKTOK_ATTRIBUTE,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },
    getTikTokCategory:async function(payload) {
        const res = await http({
                url: config.GET_TIKTOK_CATEGORY,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },
    getTikTokCategoryRule:async function(payload) {
        const res = await http({
                url: config.GET_TIKTOK_RULE_CATEGORY,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },
    getTikTokImage:async function(payload) {
        const res = await http({
                url: config.GET_TIKTOK_UPLOAD,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },
    publishTiktok:async function(payload) {
        const res = await http({
                url: config.GET_TIKTOK_PRODUCT_CREATE,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },
}